import React from 'react';
import { ApolloProvider } from '@material-bank/apollo-client';
import { CustomerProvider } from '@material-bank/customer';
import { ProjectsCustomerProvider } from '@material-bank/projects-utils';
import { App } from '@mb/App';
import { IntlProvider } from '@mb/lib/i18n/CoordinatedIntlProvider';
import { ThemeProvider } from '@mui/material';
import { theme } from 'theme';
import { PreviewFiles } from './components/previewFilesDialog/previewFiles/PreviewFiles';
import {
  GalleryImage,
  ProductAttributeJson,
  ProductConfigurableJson,
} from './types/window';

declare global {
  interface Window {
    productAttributeJson?: ProductAttributeJson;
    productConfigurableJson?: ProductConfigurableJson;
    galleryImages: GalleryImage[];
  }
}

export const SearchResultsContainer = () => {
  return (
    <App>
      <ThemeProvider theme={theme}>
        <ApolloProvider>
          <ProjectsCustomerProvider>
            <CustomerProvider>
              <IntlProvider>
                <PreviewFiles />
              </IntlProvider>
            </CustomerProvider>
          </ProjectsCustomerProvider>
        </ApolloProvider>
      </ThemeProvider>
    </App>
  );
};
